import { useEffect, useState } from "react";
import { Table } from "antd";
import axios from "axios";
import dayjs from "dayjs";
import { GiftOutlined } from "@ant-design/icons";
import { CREATE_jwel } from "../../Config/Config";
import PdfExcelPrint from "../Utilities/PdfExcelPrint";

// Shared Inventory-style components — same ones used by BankStatement.jsx
// and the other converted report screens. Adjust the path if your
// project's shared folder differs.
import styles from "../Pages/shared/Inventory.module.css";
import InventoryPageHeader from "../Pages/shared/InventoryPageHeader";
import InventoryTable from "../Pages/shared/InventoryTable";

/* ---------------- Shared card-view field maps (mobile) ---------------- */
const primaryFields = [
  { key: "Custname", label: "Customer Name" },
  { key: "Area", label: "Area" },
];
const secondaryFields = [{ key: "dob", label: "Birth Date" }];

const TodayBirthDays = () => {
  const [rawData, setRawData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [tableVisible, setTableVisible] = useState(false);
  const tenantName = localStorage.getItem("tenantName");

  /* ---- data / API logic (unchanged endpoint + query params/format) ----
     No date filter is exposed on this screen — it always pulls today's
     birthdays, so the fetch runs once on mount. */
  useEffect(() => {
    setLoading(true);
    setTableVisible(false);

    axios
      .get(
        `${CREATE_jwel}/api/ERP/GetDataFromGivenTableNameWithWhere?tableName=CUSTOMER&where=DOB='${dayjs().format(
          "MM/DD/YYYY",
        )}'`,
        {
          headers: {
            tenantName: tenantName,
          },
        },
      )
      .then((response) => {
        const detailsData = response.data;
        const calculatedData = detailsData.map((item, index) => ({
          ...item,
          key: index + 1,
          serialNo: index + 1,
        }));
        setRawData(calculatedData);
        setTimeout(() => setTableVisible(true), 80);
      })
      .catch((error) => {
        console.error("Error fetching today's birthdays:", error);
      })
      .finally(() => setLoading(false));
  }, [tenantName]);

  const columns = [
    {
      title: "S.No",
      dataIndex: "serialNo",
      width: 50,
      align: "center",
      key: "serialNo",
      className: "col-sno",
    },
    {
      title: "Custname",
      dataIndex: "Custname",
      key: "Custname",
      render: (value) => <span className="tagBadge">{value}</span>,
    },
    { title: "Area", dataIndex: "Area", key: "Area" },
    {
      title: "Birth Date",
      dataIndex: "dob",
      key: "dob",
      align: "center",
      render: (date) => (date ? dayjs(date).format("DD MMM YYYY") : "-"),
    },
  ];

  const formattedData = rawData.map((item, index) => ({
    ...item,
    serialNo: index + 1,
  }));

  const exportData = formattedData.map((item) => ({
    ...item,
    dob: item?.dob ? dayjs(item.dob).format("DD/MMM/YYYY") : "",
  }));

  return (
    <div className={styles.page}>
      <style>{`
        .ant-table-thead > tr > th {
          white-space: nowrap !important;
        }
      `}</style>

      <InventoryPageHeader
        title="Today BirthDays"
        subtitle="CRM · Today BirthDays"
        icon={<GiftOutlined style={{ color: "#fff", fontSize: 16 }} />}
        recordCount={rawData.length}
        visible={rawData.length > 0}
        stats={[{ label: "Records", value: rawData.length, color: "blue" }]}
      />

      <div
        className={styles.toolbar}
        style={{ flexWrap: "wrap", gap: 10, alignItems: "stretch" }}
      >
        <div className={styles.toolbarLeft} />

        <div className={styles.toolbarRight}>
          <PdfExcelPrint
            data={exportData}
            columns={columns}
            fileName="TodayBirthDays"
            disabled={formattedData.length === 0}
          />
        </div>
      </div>

      <InventoryTable
        columns={columns}
        dataSource={formattedData}
        rowKey="serialNo"
        tableClassName="tbd-table"
        tableEnter={tableVisible}
        loading={loading}
        emptyText="No birthdays today"
        primaryFields={primaryFields}
        secondaryFields={secondaryFields}
        summary={() => (
          <Table.Summary.Row
            style={{ background: "#f5f5f5", fontWeight: 600 }}
          >
            <Table.Summary.Cell />
            <Table.Summary.Cell />
            <Table.Summary.Cell />
            <Table.Summary.Cell />
          </Table.Summary.Row>
        )}
      />
    </div>
  );
};

export default TodayBirthDays;